<template>
    <v-container class="toggle animated" fluid>
        <v-row dense>
            <v-col cols="12" md="4">
                <v-text-field
                    v-model="search"
                    variant="outlined"
                    prepend-inner-icon="mdi-magnify"
                    label="Search"
                    density="comfortable"
                    solo
                    hide-details
                    rounded="lg"
                    color="primary"
                ></v-text-field>
            </v-col>
            <v-col class="text-right" cols="12" md="8">
                <v-btn
                @click="showAddDialog()"
                prepend-icon="mdi-plus"
                class="mt-1 rounded-lg"
                color="routesColor"
                height="40px"
                elevation="2">
                    Add Course
                </v-btn>
            </v-col>
            <v-col cols="12">
                <v-row dense>
                    <v-col cols="12">
                        <v-card class="dt-container mt-2">    
                            <v-data-table
                                :mobile="isMobileOrTablet()"
                                :headers="headers"
                                :items="data"
                                :search="search"
                                :loading="loading"
                                :items-per-page="30"
                                :items-per-page-options="[30, 50, 100, -1]"
                            >
                            <template v-slot:loading>
                                <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                            </template>
                            <template v-slot:item.status="{ item }">
                                <v-chip v-if="item.status == true" size="small" color="green" variant="elevated">
                                    Active
                                </v-chip>
                                <v-chip v-else size="small" color="red">
                                    Deactivated
                                </v-chip>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                <div class="d-flex justify-end ga-2">
                                    <v-btn @click="showEditDialog(item)" size="small" variant="outlined" text="Edit" color="orange" elevation="3"></v-btn>
                                    <!-- <v-btn size="small" variant="outlined" text="Diactivate" color="red" elevation="3"></v-btn> -->
                                </div>
                            </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>

    <CoursesDialog ref="CoursesDialog" @refresh="init()"/>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue';
import CoursesDialog from '../Dialogs/CoursesDialog.vue';

export default defineComponent({
    components: {
        CoursesDialog
    },
    data(){
        return {
            data: [],
            search: null,
            loading: false,
            headers: [
                { title: 'Title', align: 'start', sortable: true, key: 'title' },
                { title: 'Code', align: 'start', sortable: true, key: 'code' },
                { title: 'Unit', align: 'start', sortable: true, key: 'unit' },
                { title: 'Hrs. Lecture', align: 'start', sortable: true, key: 'hours_lecture' },
                { title: 'Hrs. Lab', align:  'start', sortable: true, key: 'hours_lab' },
                { title: 'Status', align:  'start', sortable: true, key: 'status' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],
        }
    },
    methods: {
        async init(){
            this.loading = true
            const token = localStorage.getItem('aums-token')
            await axios.get(process.env.VUE_APP_SERVER_URL + '/course/findAllCourseByProgram/' + this.$store.state.user.program.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.data = res.data
                    this.loading = false
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        showAddDialog(){
            this.$refs.CoursesDialog.initAdd()
        },
        showEditDialog(data){
            this.$refs.CoursesDialog.initEdit(data)
        }
    },
    mounted(){
        this.init()
    }
})
</script>

<style scoped>

</style>